import $ from 'jquery';

const selectAll = () => {
  const $selectedCheckboxes = $(`.check:checked`);
  const $actionAllSelector = $(`#actionAll`);
  if ($selectedCheckboxes.length === 0) {
    $actionAllSelector.addClass(`disabled`);
  } else {
    $actionAllSelector.removeClass(`disabled`);
  }

  const selectedNum = $selectedCheckboxes.length;
  if ($actionAllSelector.attr(`data-submitText`)) {
    const submitText = $actionAllSelector.attr(`data-submitText`);
    $actionAllSelector.text(`${submitText} (${selectedNum})`);
  } else {
    $actionAllSelector.text(`Action on All (${selectedNum})`);
  }
};

export default selectAll;
